import React from 'react';
import { Modal } from 'semantic-ui-react';
import SaveButton from './SaveButton';
import CloseButton from './CloseButton';

const Actions = ({
  children,
  closeMessageId,
  inProgress,
  minimumDataEntryMet,
  onClose,
  onSave,
  saveIcon = 'checkmark',
  saveMessageId,
}) => (
  <Modal.Actions>
    {children}
    <div>
      <CloseButton onClick={onClose} disabled={inProgress} messageId={closeMessageId} />
      <SaveButton
        iconName={saveIcon}
        inProgress={inProgress}
        minimumDataEntryMet={minimumDataEntryMet}
        onClick={onSave}
        messageId={saveMessageId}
      />
    </div>
  </Modal.Actions>
);

export default Actions;
